/* eslint-disable no-use-before-define */
/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const cartState = () => ({
  shopifyCart: null,
  loyaltyPoints: 0,
  discountCode: "",
  checkoutDetails: null,
  cartDetails: {
    totalAmount: 0,
    totalDiscount: 0,
    finalAmount: 0,
    couponDiscount: 0,
    loyaltyDiscount: 0
  },
  getRedeemablePointsApi: {
    redeemablePoints: null
  },
  applyDiscountCodeApi: {
    discountCode: null,
    discountedCart: null
  },
  applyDiscountsApi: {
    discountCode: "",
    couponDiscount: 0,
    loyaltyPoints: 0,
    discountedCart: null
  }
});

const cartSlice = createSlice({
  name: "cart",
  initialState: cartState(),
  reducers: {
    updateCartDetails(state) {
      state.cartDetails = {
        totalAmount: 0,
        totalDiscount: 0,
        finalAmount: 0,
        couponDiscount: 0,
        loyaltyDiscount: 0
      };
      state.cartDetails.totalAmount =
        state.shopifyCart.original_total_price / 100;

      state.cartDetails.loyaltyDiscount =
        state.applyDiscountsApi.loyaltyPoints || 0;

      state.cartDetails.couponDiscount =
        state.applyDiscountsApi.couponDiscount || 0;

      state.cartDetails.totalDiscount =
        state.cartDetails.couponDiscount + state.cartDetails.loyaltyDiscount;

      const defaultDis =
        (state.shopifyCart.original_total_price -
          state.shopifyCart.total_price) /
        100;
      if (
        !state.cartDetails.couponDiscount &&
        defaultDis > 0 &&
        state.applyDiscountsApi.couponDiscount
      )
        state.cartDetails.totalDiscount = defaultDis;

      state.cartDetails.finalAmount = +(
        state.cartDetails.totalAmount - state.cartDetails.totalDiscount
      ).toFixed(2);
    },
    setShopifyCart(state, { payload }) {
      state.shopifyCart = payload;
      cartSlice.caseReducers.updateCartDetails(state);
    },
    setRedeemablePoints(state, { payload }) {
      state.getRedeemablePointsApi.redeemablePoints = payload.data.points;
    },
    setGbCheckout(state, { payload }) {
      state.checkoutDetails = payload;
      const discount = payload.discountCodes?.find((code) => code.applicable);
      if (discount) {
        state.discountCode = discount.code;
        state.applyDiscountsApi.discountCode = discount.code;

        const discountAllocations = payload.discountAllocations ?? [];
        if (payload.lines?.edges?.length)
          discountAllocations.push(
            ...payload.lines.edges.flatMap(
              (edge) => edge.node.discountAllocations
            )
          );

        const discountAmount = discountAllocations.reduce(
          (acc, alc) => acc + +alc.discountedAmount.amount,
          0
        );
        state.applyDiscountsApi.couponDiscount = discountAmount;
        cartSlice.caseReducers.updateCartDetails(state);
      }
    },
    setLoyaltyPoint(state, { payload }) {
      const skuItemMap = payload.cart.items.reduce(
        (acc, item) => ({ [item.sku]: item, ...acc }),
        {}
      );

      state.shopifyCart.items = state.shopifyCart.items.map((lineItm) => ({
        ...lineItm,
        final_price:
          (skuItemMap[lineItm.sku].finalLinePrice / lineItm.quantity) * 100
      }));

      state.applyDiscountsApi.loyaltyPoints = payload.cart.loyaltyDiscount;
      cartSlice.caseReducers.updateCartDetails(state);
    },
    applyCouponCode(state, { payload }) {
      state.discountCode = payload.discountCode;
      const discountedCart = payload.data;
      state.applyDiscountsApi.discountCode = payload.discountCode;

      const skuItemMap = discountedCart.items.reduce(
        (acc, item) => ({ [item.sku]: item, ...acc }),
        {}
      );

      state.shopifyCart.items = state.shopifyCart.items.map((lineItm) => ({
        ...lineItm,
        final_price:
          +(skuItemMap[lineItm.sku].finalLinePrice / lineItm.quantity).toFixed(
            2
          ) * 100
      }));

      const { loyaltyDiscount } = discountedCart;
      const discountAmount = discountedCart.totalDiscount - loyaltyDiscount;

      state.applyDiscountsApi.couponDiscount = discountAmount;
      state.applyDiscountsApi.loyaltyPoints = loyaltyDiscount;

      state.applyDiscountsApi.discountedCart = discountedCart;
      cartSlice.caseReducers.updateCartDetails(state);
    }
  }
});

export const {
  setShopifyCart,
  setGbCheckout,
  applyCouponCode,
  setLoyaltyPoint,
  setRedeemablePoints
} = cartSlice.actions;

export default cartSlice.reducer;
